import React from 'react'

import styles from './controlCarListItem.module.scss'

const ControlCarListItem = props => {
  const handleClick = !props.disabled && props.onClick
    ? props.onClick
    : () => { }

  return (
    <button
      className={props.disabled
        ? styles.controlCarListItemDisabled
        : styles.controlCarListItem
      }
      onClick={handleClick}
    >
      { props.children}
    </button>
  )
}

export default ControlCarListItem
